module.exports = __webpack_public_path__ + "img/9788996575566.298eeff4.jpg";